export default "__VITE_ASSET__d05132f7__"